import { render } from "./RefExpense.vue?vue&type=template&id=15a0fb19&scoped=true"
import script from "./RefExpense.vue?vue&type=script&lang=js"
export * from "./RefExpense.vue?vue&type=script&lang=js"

import "./RefExpense.vue?vue&type=style&index=0&id=15a0fb19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a0fb19"]])

export default __exports__